module.exports = __webpack_public_path__ + "static/logonew-2c6580f1f8fd0b6b83c26df67a7a1b28.png";